module.exports = __webpack_public_path__ + "img/icon_user-management.146cc104.svg";